import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "clients dark-bar",
  id: "clients"
}
const _hoisted_2 = { class: "container content-section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "title text-center" }, "Our Clients", -1)
const _hoisted_4 = { class: "flex-container" }
const _hoisted_5 = { class: "col-12 col-md-6 clients-holder" }
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = {
  id: "owl-clients",
  class: "owl-carousel"
}
const _hoisted_8 = { class: "single-client" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-link2" })
], -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "clogo" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-12 col-md-1 magic-space" }, null, -1)
const _hoisted_14 = { class: "col-12 col-md-5 comments-holder" }
const _hoisted_15 = { class: "testimonial-holder" }
const _hoisted_16 = {
  id: "owl-testimonials",
  class: "owl-carousel"
}
const _hoisted_17 = { class: "testimonial-content" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "testimonial-author" }
const _hoisted_20 = { class: "user-avatar" }
const _hoisted_21 = { class: "user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestimonialModal = _resolveComponent("TestimonialModal")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.clients, (client, key) => {
                return (_openBlock(), _createBlock("div", {
                  class: "owl-testimonials",
                  key: key
                }, [
                  _createVNode("div", _hoisted_8, [
                    (client.url)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode("a", {
                            href: client.url,
                            class: "clogo",
                            target: "_blank",
                            title: client.name
                          }, [
                            _hoisted_10,
                            _createVNode("img", {
                              src: client.image,
                              alt: client.name
                            }, null, 8, ["src", "alt"])
                          ], 8, ["href", "title"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("span", _hoisted_12, [
                            _createVNode("img", {
                              src: client.image,
                              alt: client.name
                            }, null, 8, ["src", "alt"])
                          ])
                        ]))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.comments, (comment, key) => {
                return (_openBlock(), _createBlock("div", {
                  class: "testimonial",
                  key: key
                }, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", {
                      innerHTML: comment.content
                    }, null, 8, ["innerHTML"]),
                    (comment.showmore)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          _createVNode("small", null, [
                            _createVNode("a", {
                              class: "showtestimonial anchor-pointer",
                              onClick: ($event: any) => (_ctx.openTestimonialModal(key))
                            }, "[read more]", 8, ["onClick"])
                          ]),
                          _createVNode("div", {
                            class: "hide testimonial-more-desc",
                            innerHTML: comment.more.desc
                          }, null, 8, ["innerHTML"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("img", {
                        src: comment.image,
                        alt: comment.name
                      }, null, 8, ["src", "alt"])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("strong", null, _toDisplayString(comment.name), 1),
                      _createTextVNode(" " + _toDisplayString(comment.role), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_TestimonialModal, { item: _ctx.modalItem }, null, 8, ["item"])
    ])
  ]))
}